import { renderMarkdown } from 'utils/markdownRenderer';

interface IProps {
  id?: string;
  text: string;
  isMe: boolean;
  textColor?: string;
  noCursor?: boolean; // Auto determine cursor or always force to system default.
}

export const ThreadsBotError = ({ id, text }: Omit<IProps, 'isMe' & 'textColor'>) => {
  const html = renderMarkdown(text);

  return (
    <div
      id={id}
      className={`
        mb-4 max-w-[85%] self-start
        whitespace-normal break-words rounded-[10px_10px_10px_0] border border-red 
        bg-red3 p-2 font-mono 
      `}
    >
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
};

const ThreadsBotMessage: React.FC<IProps> = ({ id, text, isMe, textColor, noCursor = false }) => {
  const html = renderMarkdown(text);

  const alignment = isMe
    ? `self-end bg-blue5 text-white rounded-[10px_10px_0_10px]`
    : `self-start bg-bgSlate50 rounded-[10px_10px_10px_0]`;

  const cursorClass = noCursor ? 'cursor-default' : 'cursor-auto';

  return (
    <div
      id={id}
      className={`
        mb-4 
        max-w-[85%] 
        whitespace-normal
        break-words 
        p-2 
        ${alignment} 
        ${cursorClass}
      `}
      style={textColor ? { color: textColor } : undefined}
    >
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
};

export default ThreadsBotMessage;
